import { CaseBrowser } from '../components/CaseBrowser';

export function CasesPage() {
  return <CaseBrowser />;
}